// 获取忘记密码填写基本信息
export function getforgetPasswordDialogData() {
    return [

        {
            key: "idCard",
            name: "身份证号",
            value: '',
            type: 'input',
            isNull: false,

        },
        {
            key: "phone",
            name: "手机号",
            value: '',
            type: 'input_phone',
            isNull: false,

        },
        // {
        //     key: "code",
        //     name: "验证码",
        //     value: '',
        //     type: 'input-yzm',
        //     isNull: false,

        // },
    ]
}

//忘记密码,填写两次密码
export function getresetDialogData() {
    return [

        {
            key: "Password",
            name: "密码",
            value: '',
            type: 'input',
            isNull: false,

        },
        {
            key: "newPassword",
            name: "确认密码",
            value: '',
            type: 'input',
            isNull: false,

        },

    ]
}